module.exports = __webpack_public_path__ + "img/4.db4fa326.png";